/**
 * Session Service
 * API calls for session management
 */

import api from './api';

export const sessionService = {
  // Get all sessions with filters
  getSessions: (params = {}) => api.get('/sessions', params),

  // Get single session
  getSession: (id) => api.get(`/sessions/${id}`),

  // Get session by code (public)
  getSessionByCode: (code) => api.get(`/sessions/code/${code}`),

  // Create session
  createSession: (sessionData) => api.post('/sessions', sessionData),

  // Update session
  updateSession: (id, sessionData) => api.put(`/sessions/${id}`, sessionData),

  // Reschedule session — pick a new date/time. Body: { scheduledDate, startTime,
  // endTime?, duration? }. Backend flips status from 'expired' → 'scheduled'
  // automatically; for draft/scheduled sessions it just updates the times.
  rescheduleSession: (id, payload) => api.put(`/sessions/${id}/reschedule`, payload),

  // Delete session
  deleteSession: (id) => api.delete(`/sessions/${id}`),

  // Duplicate session with all content (subsessions, activities, workbooks)
  duplicateSession: (id, overrides = {}) => api.post(`/sessions/${id}/duplicate`, overrides),

  // Start session
  startSession: (id) => api.put(`/sessions/${id}/start`),

  // End session
  endSession: (id) => api.put(`/sessions/${id}/end`),

  // Get session participants
  getParticipants: (id) => api.get(`/sessions/${id}/participants`),

  // Get individual participant details with all responses
  getParticipantDetails: (sessionId, participantId) => api.get(`/sessions/${sessionId}/participants/${participantId}`),

  // Get session analytics
  getAnalytics: (id) => api.get(`/sessions/${id}/analytics`),

  // Live session monitor snapshot (super-admin) — single round-trip with
  // session metadata, participants (incl. device info, leave reasons,
  // disconnect history), aggregate device/browser/leave-reason mixes,
  // currently-active activity, and last 100 events.
  getLiveMonitor: (id) => api.get(`/sessions/${id}/live`),

  // Get activity results for a session
  getActivityResults: (id) => api.get(`/sessions/${id}/activity-results`),

  // Join session (for guest users without authentication)
  joinSession: (sessionId, participantData) => api.post(`/sessions/${sessionId}/join`, participantData),
};

export default sessionService;
